document.querySelectorAll('.menu-item-has-children').forEach(item => {

    const arrow = document.createElement('span');
    arrow.classList.add('submenu-toggle');
    arrow.innerHTML = 'expand_more';
    arrow.style.fontFamily = 'Google Material Icons';
    arrow.style.cursor = 'pointer';
    arrow.style.marginLeft = '5px';

    item.querySelector('a').appendChild(arrow);

    arrow.addEventListener('click', function(e) {

        const inSidebarDrawer = item.closest('[x-show]');
        if (window.innerWidth >= 1280 && !inSidebarDrawer) return;

        e.preventDefault();
        e.stopPropagation();
        item.classList.toggle('open');

    });

});